<template>
  <div>
    <Row>
      <Col span="24" style="height:170px;background-color:white;overflow:hidden;border-bottom: 1px dashed #c6cace;">
        <Col style="height:100%;">
          
          <Col span="24" style="padding:15px;" v-if="item.pic!=''">
            <Row style="text-align:left;">
              // <router-link :to="{ path: '/idetail',query:{ detailId:this.item.investmentId } }">
              //   <span
              //     style="font-size:18px;width:68%;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
              //   >{{item.investmentTitle}}</span>
              // </router-link>
              <span
                style="font-size:14px;width:30%;display:inline-block;text-align:right;"
              >发布日期:{{item.createTime}}</span>
            </Row>
            <Row>
              <Col  align="left"  style="font-size:14px;text-align:justify;height:62px;margin:10px 0px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;overflow:hidden;"  >{{item.investmentContent}}</Col>
            </Row>
            <Row style="font-size:14px;">
              <Col span="10" align="left">
                项目起止日期：
                <span style="color:red;">{{item.investmentStart}}至{{item.investmentEnd}}</span>
              </Col>
            </Row>
            <!--<Row style="font-size:14px;">
              <Col span="10" align="left">
                参考价格：
                <span style="color:red;">{{item.price}}</span>
              </Col>
              <Col span="7" align="left">
                状态：
                <span style="color:orange;">{{item.state}}</span>
              </Col>
              <Col span="7" align="left">所在地：{{item.locate}}</Col>
            </Row>-->
          </Col>
          <Col span="24" style="padding:15px;" v-if="item.pic==''">
            <Row style="text-align:left;">
              <span style="font-size:18px;width:68%;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{item.name}}</span>
              <span
                style="font-size:14px;width:30%;display:inline-block;text-align:right;"
              >发布日期:{{item.date}}</span>
            </Row>
            <Row>
              <Col
                align="left"
                style="font-size:14px;text-align:justify;height:62px;margin:10px 0px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;overflow:hidden;"
              >{{item.detail}}</Col>
            </Row>
             <Row style="font-size:14px;">
              <Col span="10" align="left">
                项目起止日期：
                <span style="color:red;">{{item.investmentStart}}-{{item.investmentEnd}}</span>
              </Col>
            </Row>
            <!--<Row style="font-size:14px;">
              <Col span="10" align="left">
                参考价格：
                <span style="color:red;">{{item.price}}</span>
              </Col>
              <Col span="7" align="left">
                状态：
                <span style="color:orange;">{{item.state}}</span>
              </Col>
              <Col span="7" align="left">所在地：{{item.locate}}</Col>
            </Row>-->
          </Col>
        </Col>
      </Col>
    </Row>
    
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    item: Object
  }
};
</script>

<style scoped>
a {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/investment/components/index.vue